import React from 'react'
import { Header } from 'antd/es/layout/layout'
import { useNavigate } from 'react-router'
import { Color } from '../../../../Common/Color'
import { Flex } from 'antd'
import TabletAssistancePhone from './TabletAssistancePhone'
import TabletSearch from './TabletSearch'

export default function TabletPublicHeader ({ withSearch = false }) {
  const navigate = useNavigate()

  return (<>
    <Header style={{
      backgroundColor: Color.white,
      '--ant-layout-header-padding': '12px 10px',
      '--ant-layout-header-height': withSearch ? '175px' : '75px',
      lineHeight: '20px'
    }}>
      <Flex align='center' justify='space-around'>
        <img onClick={() => navigate('/')} style={{ cursor: 'pointer' }} className="logo" src="/images/logo-lbm-blanc.svg" alt='Logo' width="150px" />
        <TabletAssistancePhone fontSize={'1.8em'}/>
      </Flex>
      { withSearch && <TabletSearch /> }
    </Header>
  </>
  )
}
